<template>
  <div
    class="hp-manager-page-list"
    ref="mainList"
  >
    <filter-form
      :filter="filter"
      @handleSubmit="handleSubmit"
    >
      <span
        slot="button"
        v-if="permissionChecker('Product.ActiveOpt')"
      >
        <a-button
          type="primary"
          @click="batchShelf()"
        >批量上下架</a-button>
      </span>
      <span
        slot="button"
        v-if="permissionChecker('Product.ActiveOpt')"
      >
        <a-button
          type="primary"
          @click="batchIsSaleFront()"
        >批量设置前台销售</a-button>
      </span>
      <span
        slot="button"
        v-if="permissionChecker('Product.ActiveOpt')"
      >
        <a-button
          type="primary"
          @click="batchIsAllowSplit()"
        >批量设置允许拆单</a-button>
      </span>
      <span
        slot="button"
        v-if="permissionChecker('Product.ActiveOpt')"
      >
        <a-button
          type="primary"
          @click="batchSetActivity()"
        >批量设置活动产品</a-button>
      </span>
      <span
        slot="button"
        v-if="permissionChecker('Product.ActiveOpt')"
      >
        <a-button
          type="primary"
          @click="batchSetNew()"
        >批量设置新品</a-button>
      </span>
      <span
        slot="button"
        v-if="permissionChecker('Product.ActiveOpt')"
      >
        <a-button
          type="primary"
          @click="handleBatchEditCategory()"
        >批量编辑分类</a-button><!-- 批量编辑分类-->
      </span>
      <span
        slot="button"
        v-if="permissionChecker('Freight.Set')"
      >
        <a-button
          type="primary"
          @click="handleBatchSetFreight()"
        >批量设置运费</a-button><!-- 批量编辑分类-->
      </span>
    </filter-form>
    <standard-table
      ref="datas"
      size="default"
      :bordered="true"
      :columns="columns"
      :indentSize="15"
      :dataSource="datas"
      :pagination="pagination"
      :loading="loading"
      @tableChange="tableChange"
      :scroll="scroll"
      :rowSelection="rowSelection"
    >
      <template
        slot="selfactions"
        slot-scope="rowKey"
      >
        <span>
          <a @click="handleRelation(rowKey.data)">销售范围</a>
          <a-divider type="vertical" />
          <a
            @click="handleEdit(1, rowKey.data)"
            :disabled="!permissionChecker('Product.Edit')"
          >编辑</a>
          <a-divider type="vertical" />
          <a
            @click="handlePackage(rowKey.data)"
            :disabled="!rowKey.data.isBom"
          >子件</a>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleSet(1,rowKey.data)" :disabled="!permissionChecker('Product.Edit')">活动产品</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="handleSet(2,rowKey.data)" :disabled="!permissionChecker('Product.Edit')">新品发布</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </template>
      <template
        slot="statusSwitch"
        slot-scope="rowKey"
      >
        <span>
          <a-switch
            :checked="rowKey.data.isActive && rowKey.data.isErpActive"
            @change="activeChange(rowKey.data)"
            :disabled="
              rowKey.data.isErpActive == false ||
              !permissionChecker('Product.ActiveOpt')
            "
          />
        </span>
      </template>
      <template
        slot="statusSwitch2"
        slot-scope="rowKey"
      >
        <span>
          <a-switch
            :checked="rowKey.data.isSalesInFront"
            @change="SetProductSalesInFront(rowKey.data)"
            :disabled="
              rowKey.data.isActive == false ||
              rowKey.data.isErpActive == false ||
              !permissionChecker('Product.ActiveOpt')
            "
          />
        </span>
      </template>
      <template
        slot="statusSwitch3"
        slot-scope="rowKey"
      >
        <span>
          <a-switch
            :checked="rowKey.data.isOnly"
            @change="SetProductIsOnly(rowKey.data)"
            :disabled="
              rowKey.data.isActive == false || rowKey.data.isErpActive == false
            "
          />
        </span>
      </template>
      <template
        slot="statusSwitch4"
        slot-scope="rowKey"
      >
        <span>
          <a-switch
            :checked="rowKey.data.isActivity"
            @change="SetProductIsActivity(rowKey.data)"
            :disabled="
              rowKey.data.isActive == false || rowKey.data.isErpActive == false
            "
          />
        </span>
      </template>
      <template
        slot="statusSwitch5"
        slot-scope="rowKey"
      >
        <span>
          <a-switch
            :checked="rowKey.data.isNew"
            @change="SetProductIsNew(rowKey.data)"
            :disabled="
              rowKey.data.isActive == false || rowKey.data.isErpActive == false
            "
          />
        </span>
      </template>
      <template
        slot="picShow"
        slot-scope="rowKey"
      >
        <div style="width: 50px; height: 50px">
          <img
            :src="rowKey.data.picture + '?height=50&width=50'"
            alt=""
            @click="ClickImg(rowKey.data.picture)"
          />
        </div>
      </template>
    </standard-table>
    <hp-manager-modal
      :title="params.productName + '  销售范围'"
      v-model="addOrgVisible"
      width="1200px"
    >
      <hp-manager-page-relation-list
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="addOrgVisible = false"
        :paramsX="params"
      ></hp-manager-page-relation-list>
    </hp-manager-modal>
    <hp-manager-modal
      :width="modalWidth"
      :title="title"
      v-model="addVisible"
    >
      <hp-manager-page-product-add
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="addVisible = false"
        :params="params"
      ></hp-manager-page-product-add>
    </hp-manager-modal>
    <hp-manager-modal
      :title="params.productName + '  子件明细'"
      v-model="packageListVisible"
      width="1200px"
    >
      <hp-manager-page-package-list
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="packageListVisible = false"
        :paramsX="params"
      ></hp-manager-page-package-list>
    </hp-manager-modal>
    <hp-manager-modal
      :title="'批量编辑产品分类'"
      v-model="batchEditVisible"
      width="500px"
    >
      <hp-manager-page-batch-edit
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="batchEditVisible = false"
        :paramsB="params"
      ></hp-manager-page-batch-edit>
    </hp-manager-modal>

    <hp-manager-modal
      :title="'持续时间设置'"
      v-model="setVisible"
      width="500px"
    >
      <hp-manager-page-set-product
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="setVisible = false"
        :paramsS="params"
      ></hp-manager-page-set-product>
    </hp-manager-modal>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
    >
      <img
        style="width: 100%; padding: 15px"
        :src="previewImage"
      />
    </a-modal>

    <hp-manager-modal
      v-model="batchSetFreightVisible"
      :title="'批量设置运费'"
      width="600px"
    >
      <hp-manager-page-set-freight
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="batchSetFreightVisible = false"
        :params="params"
      />
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";
import hpManagerPageRelationList from "./RelationOrgList";
import hpManagerPageProductAdd from "./Add";
import hpManagerPagePackageList from "./PackageList";
import hpManagerPageBatchEdit from "./BatchEdit";
import hpManagerPageSetProduct from "./SetProduct";
import hpManagerPageSetFreight from "./SetFreight";
export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageRelationList,
    hpManagerPageProductAdd,
    hpManagerPagePackageList,
    hpManagerPageBatchEdit,
    hpManagerPageSetProduct,
    hpManagerPageSetFreight
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "ProductName",
          name: "产品名称"
        },
        {
          type: "input",
          key: "ProductCode",
          name: "产品编码"
        },
        /*         {
          type: "select",
          key: "productSeries",
          name: "产品系列",
          options: []
        }, */
        {
          type: "select",
          key: "hasPicture",
          name: "是否有图",
          options: [{ name: "是", val: 1 }, { name: "否", val: 0 }]
        },
        {
          type: "select",
          key: "includeCustom",
          name: "是否定制",
          options: [{ name: "是", val: 1 }, { name: "否", val: 0 }]
        },
        {
          type: "select",
          key: "isBom",
          name: "是否套件",
          options: [{ name: "是", val: 1 }, { name: "否", val: 0 }]
        },
        {
          type: "select",
          key: "isNew",
          name: "是否新品",
          options: [{ name: "是", val: 1 }, { name: "否", val: 0 }]
        },
        {
          type: "select",
          key: "isActivity",
          name: "是否活动",
          options: [{ name: "是", val: 1 }, { name: "否", val: 0 }]
        },
        {
          type: "select",
          key: "isActive",
          name: "状态",
          options: [{ name: "上架", val: 1 }, { name: "下架", val: 0 }]
        },
        {
          type: "cascader",
          key: "productCategory",
          name: "产品分类",
          options: []
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 190,
          scopedSlots: { customRender: "action" },
          fixed: true
        },
        {
          title: "产品编码",
          dataIndex: "productCode",
          width: 160,
          sorter: true
        },
        {
          title: "产品名称",
          dataIndex: "productName",
          width: 240,
          sorter: true
        },
        // {
        //   title: "规格属性",
        //   dataIndex: "specDes",
        //     width: 140,
        // },
        {
          title: " 缩略图",
          width: 100,
          dataIndex: "picture",
          scopedSlots: { customRender: "pic" }
        },
        // {
        //   title: "产品系列",
        //   dataIndex: "productSeriesName",
        //   width: 100
        // },
        {
          title: "产品分类",
          dataIndex: "productCategoryName",
          width: 240
        },
        {
          title: "定制",
          dataIndex: "isCustom",
          width: 80,
          customRender: (text, row, index) => {
            return row.isCustom ? "是" : "否";
          }
        },
        // {
        //   title: "套件",
        //   dataIndex: "isBom",
        //   width: 80,
        //   customRender: (text, row, index) => {
        //     return row.isBom ? "是" : "否";
        //   }
        // },
        // {
        //   title: "单位",
        //   dataIndex: "measureUnitName",
        //   width: 80
        // },
        {
          title: "销售类型",
          dataIndex: "saleTypeName",
          width: 100
        },
        // {
        //   title: "体积",
        //   dataIndex: "volume",
        //   width: 100,
        //   sorter: true
        // },
        // {
        //   title: "重量",
        //   dataIndex: "weight",
        //   width: 100,
        //   sorter: true
        // },
        {
          title: "预计交期(天)",
          dataIndex: "expectedDelivery",
          width: 130,
          sorter: true
        },
        {
          title: "运费项目",
          dataIndex: "freightName",
          width: 100
        },
        {
          title: "运费",
          dataIndex: "freightAmount",
          width: 100
        },
        {
          title: "活动有效期",
          dataIndex: "activityEndTime",
          width: 200,
          customRender: (text, row, index) => {
            return (
              this.formatDate(row.activityStartTime, "YYYY-MM-DD") +
              " ~ " +
              this.formatDate(row.activityEndTime, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "新品有效期",
          dataIndex: "newEndTime",
          width: 200,
          customRender: (text, row, index) => {
            return (
              this.formatDate(row.newStartTime, "YYYY-MM-DD") +
              " ~ " +
              this.formatDate(row.newEndTime, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "上架状态",
          dataIndex: "isActive",
          width: 100,
          scopedSlots: { customRender: "status" }
        },
        {
          title: "前台销售",
          dataIndex: "isSalesInFront",
          width: 100,
          scopedSlots: { customRender: "status2" }
        },
        {
          title: "是否拆单",
          dataIndex: "isOnly",
          width: 100,
          scopedSlots: { customRender: "status3" }
        },
        {
          title: "活动产品",
          dataIndex: "isActivity",
          width: 100,
          scopedSlots: { customRender: "status4" }
        },
        {
          title: "是否新品",
          dataIndex: "isNew",
          width: 100,
          scopedSlots: { customRender: "status5" }
        },

        {
          title: "修改时间",
          dataIndex: "creationTime",
          width: 160,
          sorter: true,
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      scroll: { x: 1640 },
      filterdata: Object.assign(
        {
          ProductName: "",
          ProductCode: "",
          isActive: "",
          productCategory: "",
          isNew: "",
          isActivity: ""
        },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      addOrgVisible: false,
      setVisible: false,
      batchEditVisible: false,
      packageListVisible: false,
      batchSetFreightVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "1300px",
      title: "",
      selectedRowKeys: [],
      selectedIds: [],
      rowSelection: null,
      previewVisible: false,
      previewImage: null,
      allCategory: []
    };
  },
  async mounted() {
    this.scroll.x = 0;
    this.columns.forEach(a => {
      this.scroll.x = a.width + this.scroll.x;
    });
    this.rowSelection = {
      onChange: this.onSelectChange,
      getCheckboxProps: this.disableCheckbox
    };
    this.getAllCategory();
    this.getDatas(this.filterdata);
    //this.getProductSeries();
  },

  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.ProductName = p.values.ProductName;
      this.filterdata.ProductCode = p.values.ProductCode;
      this.filterdata.isActive = p.values.isActive;
      this.filterdata.productSeries = p.values.productSeries;
      this.filterdata.hasPicture = p.values.hasPicture;
      this.filterdata.productCategory =
        p.values.productCategory != null && p.values.productCategory.length > 1
          ? p.values.productCategory[1]
          : null;
      this.filterdata.includeCustom = p.values.includeCustom;
      this.filterdata.isBom = p.values.isBom;
      this.filterdata.isNew = p.values.isNew;
      this.filterdata.isActivity = p.values.isActivity;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedIds = [];
      selectedRows.forEach(x => {
        this.selectedIds.push(x.id);
      });
      console.log(this.selectedIds);
      this.rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: this.disableCheckbox
      };
    },
    ClickImg(data) {
      console.log(data);
      this.previewImage = data;
      this.previewVisible = true;
    },
    async getAllCategory() {
      let categoryList = await api.GetAllProductCategoryForCascader();
      if (categoryList) {
        this.allCategory = categoryList;
      }
      this.filter.filter(
        a => a.key == "productCategory"
      )[0].options = categoryList;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    disableCheckbox(record) {
      return {
        props: {
          disabled: record.isErpActive === false,
          name: record.id.toString()
        }
      };
    },
    async batchShelf() {
      if (this.selectedIds && this.selectedIds.length > 0) {
        await api.batchShelfProduct({ productIdList: this.selectedIds });
      } else {
        this.$message.warn("请先选择需要上架的产品");
      }
      this.refreshCurrent();
    },
    async batchIsSaleFront() {
      if (this.selectedIds && this.selectedIds.length > 0) {
        await api.batchSaleShelfProduct({ productIdList: this.selectedIds });
        this.refreshCurrent();
      } else {
        this.$message.warn("请先选择需要展示在商城的产品");
      }
    },
    //批量设置允许拆单
    async batchIsAllowSplit() {
      if (this.selectedIds && this.selectedIds.length > 0) {
        await api.batchIsAllowSplit({ productIdList: this.selectedIds });
        this.refreshCurrent();
      } else {
        this.$message.warn("请先选择需要展示在商城的产品");
      }
    },
    //批量修改分类
    async handleBatchEditCategory() {
      if (this.selectedIds && this.selectedIds.length > 0) {
        this.params = Object.assign({ productIdList: this.selectedIds });
        this.batchEditVisible = true;
      } else {
        this.$message.warn("请先选择产品");
      }
    },
    async handleBatchSetFreight() {
      if (this.selectedIds && this.selectedIds.length > 0) {
        this.params = Object.assign({ productIdList: this.selectedIds });
        this.batchSetFreightVisible = true;
      } else {
        this.$message.warn("请先选择产品");
      }
    },
    //批量设置新品
    async batchSetNew() {
      if (this.selectedIds && this.selectedIds.length > 0) {
        this.params = Object.assign(
          { productIdList: this.selectedIds },
          { type: 4 }
        );
        this.setVisible = true;
      } else {
        this.$message.warn("请先选择产品");
      }
    },
    //批量设置活动产品
    async batchSetActivity() {
      if (this.selectedIds && this.selectedIds.length > 0) {
        this.params = Object.assign(
          { productIdList: this.selectedIds },
          { type: 3 }
        );
        this.setVisible = true;
      } else {
        this.$message.warn("请先选择产品");
      }
    },
    async getProductSeries() {
      let dictionary = await api.GetDictionaryForSelect({ type: 4 });
      let productSeriesOptions = [];
      if (dictionary) {
        dictionary.forEach(a => {
          productSeriesOptions.push({
            name: a.text,
            val: a.value
            //disabled: a.disabled
          });
        });
      }
      this.filter.filter(
        a => a.key == "productSeries"
      )[0].options = productSeriesOptions;
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑产品";
      } else if (type == 2) {
        this.title = "产品详情";
        this.isabl = true;
      } else {
        this.title = "新增产品";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    async activeChange(record) {
      let active = await api.ActiveProduct({ id: record.id });
      this.refreshCurrent();
    },
    async SetProductSalesInFront(record) {
      let active = await api.SetProductSalesInFront({ id: record.id });
      this.refreshCurrent();
    },
    async SetProductIsOnly(record) {
      let active = await api.SetProductOnlyOrder({ id: record.id });
      this.refreshCurrent();
    },
    async SetProductIsActivity(record) {
      if (record.isActivity == true) {
        let active = await api.SetProductIsActivity({ id: record.id });
        this.refreshCurrent();
      } else {
        this.params = Object.assign({ type: 1 }, record);
        this.setVisible = true;
      }
    },

    async SetProductIsNew(record) {
      if (record.isNew == true) {
        let active = await api.SetProductIsNew({ id: record.id });
        this.refreshCurrent();
      } else {
        this.params = Object.assign({ type: 2 }, record);
        this.setVisible = true;
      }
    },
    handleRelation(record) {
      this.params = record;
      this.addOrgVisible = true;
    },
    handlePackage(record) {
      this.params = record;
      this.packageListVisible = true;
    },

    // //删除数据
    // async deldata(row) {
    //   let that = this;
    //   new Promise(async (resolve, reject) => {
    //     this.$confirm({
    //       title: "警告",
    //       content: "确定要删除此数据?",
    //       okText: "删除",
    //       centered: "centered",
    //       okType: "danger",
    //       cancelText: "取消",
    //       onOk() {
    //         that.delHandle(row);
    //       },
    //       onCancel() {
    //         console.log("Cancel");
    //       }
    //     });
    //   });
    // },
    // async delHandle(row) {
    //   let msgRet = await api.DelProduct({ id: row.id });
    //   if (msgRet) {
    //     this.$message.success("删除成功");
    //     if (
    //       this.pagination.total - 1 <=
    //       this.pagination.pageSize * (this.pagination.current - 1)
    //     ) {
    //       this.filterdata.skipCount =
    //         this.pagination.current == 1
    //           ? 0
    //           : (this.pagination.current - 2) * this.maxResultCount;
    //       this.pagination.current =
    //         this.pagination.current == 1 ? 1 : this.pagination.current - 1;
    //     }
    //     this.getDatas(this.filterdata);
    //   }
    // },

    refreshCurrent() {
      //  this.pagination.current = 0;
      this.addVisible = false;
      this.addOrgVisible = false;
      this.packageListVisible = false;
      this.batchEditVisible = false;
      this.setVisible = false;
      this.batchSetFreightVisible = false;
      this.rowSelection = {
        selectedRowKeys: [],
        onChange: this.onSelectChange,
        getCheckboxProps: this.disableCheckbox
      };
      //  this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetProductList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Goods/Product/List.vue